import React from 'react';
import { Box, Typography, Accordion, AccordionSummary, AccordionDetails, Button, useTheme } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { ExpandMore } from '@mui/icons-material';

interface MenuItem {
    subMenu: {
        title: string,
        buttons: {
            name: string,
            route: string,
        }[]
    }
}

interface MobileMenuProps {
    menus: MenuItem[];
}

const MobileMenu: React.FC<MobileMenuProps> = ({ menus }) => {
    const navigate = useNavigate();
    const theme = useTheme(); 

    const url = window.location.href;
    const segmentsUrl = url.split('/');
    const sliceUrl = segmentsUrl.slice(5);
    const stringUrl = sliceUrl.join('');
    const stringToCompare = stringUrl === '' ? 'nada' : stringUrl;

    function getFile(stringToCompare: string) {
        if (stringToCompare.includes('filesfile')) {
            return ('files/file');
        } else if (stringToCompare.includes('filesfoto')) {
            return ('files/foto');
        }
        return stringToCompare;
    }

    const finalString = getFile(stringToCompare);

    return (
        <Box width='95%' justifyContent='center'>
            <Box>
                <Accordion variant='outlined'>
                    <AccordionSummary expandIcon={<ExpandMore />}>
                        <Box width='100%' justifyContent='center'>
                            <Typography align='center' color={theme.palette.primary.main}>Menu</Typography>
                        </Box>
                    </AccordionSummary>
                    <AccordionDetails>
                        {menus.map((menu, index) => (
                            <Box key={`${menu.subMenu.title}-${index}`} padding={1}>
                                <Accordion variant='outlined'>
                                    <AccordionSummary expandIcon={<ExpandMore />}>
                                        <Box width='100%' justifyContent='center'>
                                            <Typography align='center'
                                                color={
                                                    menu.subMenu.buttons.some(item => (item.route.includes(finalString))) ?
                                                        theme.palette.primary.main : theme.palette.text.primary
                                                }
                                                variant={
                                                    menu.subMenu.buttons.some(item => (item.route.includes(finalString))) ?
                                                        'body1' : 'body2'
                                                }
                                            >
                                                {menu.subMenu.title}
                                            </Typography>
                                        </Box>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <Box display='flex' flexDirection='column' gap={0.5} alignContent='start'>
                                            {menu.subMenu.buttons.map((button) => (
                                                <Box key={button.route} alignContent='start' display='flex'>
                                                    <Button onClick={() => navigate(button.route)}
                                                        fullWidth
                                                        variant={button.route.includes(finalString) ? 'contained' : 'text'}
                                                        disabled={button.route.includes(finalString) ? true : false}
                                                    >
                                                        <Typography variant='body2'>{button.name}</Typography>
                                                    </Button>
                                                </Box>
                                            ))}
                                        </Box>
                                    </AccordionDetails>
                                </Accordion>
                            </Box>
                        ))}
                    </AccordionDetails>
                </Accordion>
            </Box>
        </Box>
    );
};

export default MobileMenu;